<template>
  <iframe
    sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
    allowfullscreen="true"
    :src="src"
    :style="{
      display: 'block',
      border: 'none',
      position: 'absolute',
      width: '100%',
      height: 'calc(100dvh - var(--nav-height) - 48px)'
    }"
  />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['currentLang', 'selectedBot']),
    src() {
      if (!this.currentLang) return ''
      return `https://ananda.analytics.enterprise.zwiz.app/${this.currentLang}/comments`
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      const { id, value } = event.data
      switch (id) {
        case 'view-all-in-one-chat': {
          const { search, inbox, app } = value

          let routeData = this.$router.resolve({
            name: 'livechat',
            path: '/' + this.currentLang + '/livechat',
            query: {
              userid: search,
              user: inbox,
              app: app,
              pageid: this.selectedBot.pageid
            }
          })
          if (this.selectedBot.features.includes('all-in-one-chat-new')) {
            routeData = this.$router.resolve({
              name: 'allinonechat-new',
              path: '/' + this.currentLang + '/allinonechat-new',
              query: {
                search,
                inbox,
                app
              }
            })
          }
          this.$router.push(routeData.href)
          break
        }

        case 'open-bill': {
          window.open(value, '_blank')
          break
        }

        case 'copy-user-id': {
          navigator.clipboard.writeText(value)
          break
        }
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/CommentIframe.vue